<template>
  <asc-dialog
    :show-dialog="showDialog"
    text="Fault Monitor"
    :on-close="handleClose"
    :width="400"
  >
    <template v-if="showDialog">
      <asc-fault-monitor-alert
        :definition="definition"
        :loading="loading"
      ></asc-fault-monitor-alert>
    </template>
  </asc-dialog>
</template>

<script>
import { AscDataDefinitionMixin, AscDialogMixin } from '@/components/mixins'
import AscDialog from '@/components/atoms/AscDialog'
import AscFaultMonitorAlert from './AscFaultMonitorAlert'

export default {
  name: 'AscFaultMonitorAlertDialog',

  components: {
    AscDialog,
    AscFaultMonitorAlert,
  },

  mixins: [AscDataDefinitionMixin, AscDialogMixin],
}
</script>
